import { useAssociatedObjectsForDefinition } from './useAssociatedObjectsForDefinition';
export const useAssociations = (objectId, hasCustomAssociationGetter, primaryAssociationDefinition, secondaryAssociationDefinition) => {
  const primaryAssociation = useAssociatedObjectsForDefinition(objectId, primaryAssociationDefinition, hasCustomAssociationGetter);
  const secondaryAssociation = useAssociatedObjectsForDefinition(objectId, secondaryAssociationDefinition, hasCustomAssociationGetter);
  return [primaryAssociation, secondaryAssociation].flat();
};